import { createUseStyles } from 'react-jss'
import { colors } from '../../../variables.style'

export const style = {
  tabs: {
    display: 'flex',
    marginTop: 20
  },
  tab: {
    flex: 1,
    color: 'black',
    border: `1px solid ${colors.borderGray}`,
    cursor: 'pointer',
    padding: 5,
    textAlign: 'center',
    textTransform: 'uppercase',
    borderTopLeftRadius: 25,
    borderTopRightRadius: 5,
    height: 35,
    fontSize: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:first-child': {
      borderTopLeftRadius: 25,
      borderTopRightRadius: 5
    },
    '&:last-child': {
      borderTopLeftRadius: 5,
      borderTopRightRadius: 25
    }
  },
  activeTab: {
    extend: 'tab',
    fontWeight: 'bold',
    backgroundColor: colors.backgroundGray,
    borderBottom: 'none'
  },
  tabContent: {
    border: `1px solid ${colors.borderGray}`,
    borderTop: 'none',
    backgroundColor: colors.backgroundGray,
    padding: 15
  },
  tabContentField: {
    '&:not(:last-child)': {
      marginBottom: 10
    }
  },
  tabContentFieldGrid: {
    extend: 'tabContentField',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: 10
  }
}

export const useStyles = createUseStyles(style)
